/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { ContextMenuHeader } from "components/contextMenu/ContextMenuHeader";
import { contextMenuManager } from "contextMenuManager";
import { pageContentHandler } from "pageContentHandler";
import { isTouchSelectionPresent, isThereAnySelection } from "dc-preview-utils/src/selectors/touchSelectors";
import { getContextMenuTriggerEventObj } from "selectors/contextMenuSelectors";
import { getZoomedQuadsObj } from "utils/SelectionUtils";
import { getShouldUseModernViewer } from "selectors/appSelectors";
import { getCurrentPageIndex } from "selectors/pageNumber";

function mapStoreToProps(stores, ownProps) {
  return {
    getExtraParams: () => {
      const params = {};
      if (isThereAnySelection(stores)) {
        const quadsObj = pageContentHandler.getTextManagerInstance().quads;
        if (quadsObj && quadsObj.quadsArray) {
          params.quads = getZoomedQuadsObj(quadsObj.quadsArray, stores);
        }
      }
      params.pageIndex = getCurrentPageIndex(stores);
      params.contextMenuTriggerEventObj = getContextMenuTriggerEventObj(stores);
      return params;
    },
    ...ownProps,
    clearTouchSelectionIfPresent: () => {
      if (isTouchSelectionPresent(stores) === true) {
        contextMenuManager.clearMenuItems(stores);
        pageContentHandler.getTextManagerInstance().clearSelection(stores);
      }
    },
    useModernViewer: getShouldUseModernViewer(stores)
  };
}

const ContextMenuHeaderContainer = inject(mapStoreToProps)(ContextMenuHeader);

export { ContextMenuHeaderContainer };
